const prefix = 'far';
const iconName = 'square-check';
const width = 448;
const height = 512;
const aliases = [9745, 9989, 61510, 'check-square'];
const unicode = 'f14a';
const svgPathData = 'M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
